module.exports = __webpack_public_path__ + "static/spiderman-736c972bd9f83ea2cbbe2725e7bdef22.svg";